module.exports = __webpack_public_path__ + "media/images/products/products/ed1-d52d68cecd402a5481ee9f41dd8f7323.jpg";